import React from 'react';
import ErrorBoundary from 'components/ErrorBoundary';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import globalMessages from 'translations/messages';
import NoMatch from 'containers/NoMatch';
import { EDIT_REPORT } from 'shared/constants/permissions';

import Reports from './Reports';
import EditReport from './EditReport';
import PreviewReport from './PreviewReport';
import useCustomer from '../../hooks/useCustomer';

const ReportsNav = () => {
  const match = useRouteMatch();
  const { hasCustomerPermission } = useCustomer();

  const routes = [
    {
      path: '',
      name: globalMessages.reports,
      component: Reports,
      visible: true,
    },
    {
      path: '/:reportId/edit/:step?',
      name: globalMessages.reports,
      component: EditReport,
      visible: hasCustomerPermission(EDIT_REPORT),
    },
    {
      path: '/:reportId/:date?',
      name: globalMessages.reports,
      component: PreviewReport,
      visible: true,
    },
  ].filter(item => item.visible);

  return (
    <ErrorBoundary>
      <Switch>
        {routes.map(route => (
          <Route
            key={route.path}
            exact
            path={`${match.url}${route.path}`}
            render={props => (
              <ErrorBoundary>
                <route.component {...props} />
              </ErrorBoundary>
            )}
          />
        ))}

        <Route path="*" component={NoMatch} />
      </Switch>
    </ErrorBoundary>
  );
};

export default ReportsNav;
